import api from "./api";
import { APIS } from "../endpoints";

/**
 * This function return songs data
 * @returns {Promise<Object>} - Function return Songs data
 */

// export const getArchiveData = async (limit, page) => {
//     const response = await getArchiveAPIData(limit, page);
//     return response;
// };

export const getAllQuestionsData = async (limit, page, postAlias, searchTerm) => {
    const formData = new FormData();
    formData.append('page', page);
    formData.append('limit', limit);

    if (searchTerm) {
        formData.append('search', searchTerm); // Add search term
    }

    const params = new URLSearchParams(formData);
    const result = await api.get(`${APIS.BASE_URL}${APIS.posts}/${postAlias}/quiz?isType=posts`, {
        params: params
    })

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const getQuestionData = async (alias, questionId) => {
    // Construct the endpoint URL conditionally based on the presence of `section`
    const endpoint = `${APIS.BASE_URL}admin/posts/${alias}/quiz/${questionId}`;

    try {
        const result = await api.get(endpoint);

        // Return the `data` if the result exists, otherwise return an empty array
        return result?.data?.data || [];
    } catch (error) {
        console.error('Error fetching libraries data:', error);
        return [];
    }
};

export const updateQuestionData = async (alias, questionId, data, deletedValues) => {

    const payload = {
        ...data,
        deletedValues: deletedValues
    };

    const result = await api.put(`${APIS.BASE_URL}admin/posts/${alias}/quiz/${questionId}`, payload)

    if (result) {
        return result?.data;
    } else {
        return [];
    }
}

export const createNewQuestion = async (alias, data, isType) => {

    const result = await api.post(`${APIS.BASE_URL}admin/posts/${alias}/quiz?isType=${isType}`, data)

    if (result) {
        return result?.data;
    } else {
        return [];
    }
}